import script from "./RegisterPlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPlanCard.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPlanCard.vue?vue&type=style&index=0&id=0d7847a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7847a0"]])

export default __exports__